export default "__VITE_ASSET__af25fb94__"